// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__2axWs","alt":"Title_alt__3r1cu","subtitle":"Title_subtitle__Bw5id","secondary":"Title_secondary__3seX6"};